import { render, staticRenderFns } from "./CreateReceiveForm.vue?vue&type=template&id=87a1f694"
import script from "./CreateReceiveForm.vue?vue&type=script&lang=js"
export * from "./CreateReceiveForm.vue?vue&type=script&lang=js"
import style0 from "./CreateReceiveForm.vue?vue&type=style&index=0&id=87a1f694&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports